import { AbstractLookupStore } from "../common/AbstractStores";
import { CaldaiaDto } from "../generated";
import Dispatcher from "../common/dispatcher";
import Actions from "./caldaieActions";

class CaldaieStore extends AbstractLookupStore<CaldaiaDto>{
    constructor() {
        super();
        Dispatcher
            .onfunction(Actions.getListaNuoveCaldaiePrecaricate, ({ marca, caldaie }) => this.set(marca, caldaie!))
            .onfunction(Actions.inserisciCaldaiePrecaricate, () => this.deleteAll())
            ;
    }
}

export default new CaldaieStore();
